.uk-alert {
    padding: 1rem;
    border-radius: 4px;
    position: relative;
    font-size: 1rem;
    color: #fff;
    display: block;

    .message {
        margin-right: 2rem;
    }

    .close {
        position: absolute;
        top: 12px;
        right: 10px;
        background: transparent;
        border: none;
        font-size: 1.25rem;
        color: inherit;
        cursor: pointer;
    }
}

.uk-alert-success {
    background-color: #28a745;
}

.uk-alert-warning {
    background-color: #ffc107;
    color: #000;
}

.uk-alert-danger {
    background-color: #dc3545;
}

.uk-alert-info {
    background-color: #17a2b8;
}
